import { useMemo, useState } from 'react';
import MechanicalTab from 'src/@carketa/sales-packet/components/MechanicalTab';
import { CarketaDisclosure } from 'src/@carketa/sales-packet/components/CarketaDisclosure';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/ui/tabs';
import { cn } from 'src/utils/@/lib/utils';

type VehicleConditionReportSection = {
  vehicle: any;
  vehicle_inspections: any;
  inspectionId: string | null;
  pdfMode?: boolean;
};

const VehicleConditionReportSection = ({
  vehicle,
  vehicle_inspections,
  inspectionId,
  pdfMode,
}: VehicleConditionReportSection) => {
  const [value, setValue] = useState('0');

  const vehicle_inspection = useMemo(() => {
    let inspection = null;
    inspection = vehicle_inspections?.find((inspection: any) => inspection.id === inspectionId);
    if (!inspection && vehicle_inspections) inspection = vehicle_inspections?.[0];
    return inspection;
  }, [inspectionId, vehicle_inspections]);

  if (!vehicle_inspection) return <>No Published Vehicle Inspections Found.</>;

  return (
    <div id="vehicle-reports" className="w-full p-2">
      <div className="mb-4 mt-5 w-full border-t border-gray-300" />
      <div className="mb-4 flex flex-col justify-between">
        <p className="text-16 font-medium">{vehicle_inspection.inspection_template.title}</p>
        <p className="text-16">
          {vehicle.year} {vehicle.make} {vehicle.model} {vehicle.trim}
        </p>
      </div>
      <div className="flex">
        <p className="text-14 mr-4">VIN</p>
        <p className="text-14 gray-500">{vehicle.vin}</p>
      </div>
      <div className="flex">
        <p className="text-14 mr-4">STOCK#</p>
        <p className="text-14 gray-500">{vehicle.stocknumber}</p>
      </div>
      <div className="mt-[15px] w-full">
        <Tabs value={value} onValueChange={setValue}>
          <div className="border-b border-border">
            <TabsList variant="outlined" color="success">
              <TabsTrigger value="0" className="font-bold">
                MECHANICAL
              </TabsTrigger>
            </TabsList>
          </div>
          <TabsContent value="0" className="pt-6">
            <MechanicalTab vehicle_inspection={vehicle_inspection} />
          </TabsContent>
        </Tabs>
      </div>
      <div className={cn(!pdfMode && 'hidden')}>
        <CarketaDisclosure />
      </div>
    </div>
  );
};

export default VehicleConditionReportSection;
